import { render, staticRenderFns } from "./joinedGuild.vue?vue&type=template&id=4cb49552&scoped=true&"
import script from "./joinedGuild.vue?vue&type=script&lang=js&"
export * from "./joinedGuild.vue?vue&type=script&lang=js&"
import style0 from "./joinedGuild.vue?vue&type=style&index=0&id=4cb49552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb49552",
  null
  
)

export default component.exports